// Admin layout specific JavaScript functions

function toggleSidebar() {
  const sidebar = document.getElementById("adminSidebar");
  const overlay = document.getElementById("sidebarOverlay");
  sidebar.classList.toggle("-translate-x-full");
  overlay.classList.toggle("hidden");
}

function toggleDropdown(id) {
  const dropdown = document.getElementById(id);
  dropdown.classList.toggle("hidden");
}

// Close dropdown when clicking outside
document.addEventListener("click", function (event) {
  const dropdowns = document.querySelectorAll('[id$="Dropdown"]');
  dropdowns.forEach((dropdown) => {
    if (!dropdown.closest(".relative").contains(event.target)) {
      dropdown.classList.add("hidden");
    }
  });
});

// Make functions globally available
window.toggleSidebar = toggleSidebar;
window.toggleDropdown = toggleDropdown;
